import {useAppRouterContext} from './AppRouterContext';

const useAppLocation = () => {
  const {location} = useAppRouterContext();
  return location;
};

export default useAppLocation;
